// Shared journey pointer for the Find Cases wizard:
// Select Court → Search Case → Results → Import Case. `current` is 1-based.
// Every circle always shows its NUMBER (active = indigo + ring, done = indigo,
// upcoming = outlined). Past steps are clickable and navigate back to that step.
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const STEPS = [
  { n: 1, label: "Select Court" },
  { n: 2, label: "Search Case" },
  { n: 3, label: "Results" },
  { n: 4, label: "Import Case" },
];

export default function FindCaseStepper({ current = 1 }) {
  const navigate = useNavigate();

  // A past step is reachable: step 1 always jumps to the court chooser; earlier
  // steps go back the right number of history entries (the flow is linear).
  const goToStep = (n) => {
    if (n >= current) return;
    if (n === 1) navigate("/portal/findCasesOptions");
    else navigate(-(current - n));
  };

  return (
    <div>
      <div className="flex flex-wrap items-center gap-y-2">
        {STEPS.map((s, i) => {
          const done = current > s.n;
          const active = current === s.n;
          const clickable = s.n < current;
          return (
            <div key={s.n} className="flex items-center">
              <button
                type="button"
                disabled={!clickable}
                onClick={() => goToStep(s.n)}
                className={`flex items-center gap-2 ${clickable ? "cursor-pointer" : "cursor-default"}`}
                title={clickable ? `Go to ${s.label}` : undefined}
              >
                <span
                  className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold transition-transform ${
                    active
                      ? "bg-indigo-600 ring-4 ring-indigo-100"
                      : done
                      ? "bg-indigo-600 hover:scale-105"
                      : "border-2 border-slate-300 bg-white text-slate-500"
                  }`}
                  style={active || done ? { color: "#ffffff" } : undefined}
                >
                  {s.n}
                </span>
                <span
                  className={`whitespace-nowrap text-sm font-semibold ${
                    active ? "text-slate-900" : done ? "text-slate-700 hover:text-indigo-600" : "text-slate-400"
                  }`}
                >
                  {s.label}
                </span>
              </button>
              {i < STEPS.length - 1 && (
                <span className="mx-2 flex items-center sm:mx-4">
                  <span className="h-px w-6 bg-slate-200 sm:w-12" />
                  <ChevronRight className="h-4 w-4 text-slate-300" />
                </span>
              )}
            </div>
          );
        })}
      </div>
      {/* Rule that separates the wizard pointer from the page body below it. */}
      <div className="mt-4 h-px w-full bg-slate-200" />
    </div>
  );
}
